import { useMutation, useQueryClient } from '@tanstack/react-query'
import ConfirmationModal from 'components/ConfirmationModal'
import { QUERY_KEYS } from 'constants/keys'
import { ROUTES } from 'constants/routes'
import { useGlobalState } from 'contexts/global-state'
import { useNavigate } from 'react-router-dom'
import { ApiService } from 'services/api'

type DeleteProps = {
  opened: boolean
  closeModal: () => void
  role?: Role
}

export default function Delete({ opened, closeModal, role }: DeleteProps) {
  const { openErrorToast, openSuccessToast } = useGlobalState()
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  const removeRole = useMutation({
    mutationFn: async (role: Role) => {
      await ApiService.Roles.remove(role.id.toString())

      openSuccessToast({
        message: `O grupos de usuário ${role?.name} foi removido com sucesso!`,
      })

      navigate(ROUTES.ROLES.LIST)
    },
    onSuccess: (_data, role: Role) => {
      queryClient.setQueryData<CommercialUnit[]>(
        QUERY_KEYS.ROLES.LIST,
        (oldRoles) => {
          if (!oldRoles?.length) return

          return oldRoles.filter((oldRole) => oldRole.id !== role.id)
        },
      )

      queryClient.removeQueries(QUERY_KEYS.ROLES.EDIT(role.id.toString()))

      openSuccessToast({
        message: `O grupos de usuário ${role.name} foi removido com sucesso!`,
      })

      navigate(ROUTES.ROLES.LIST)
    },
    onError: (removeError) => {
      closeModal()

      openErrorToast({
        message: (removeError as ApiError).message,
      })
    },
  })

  if (!opened) {
    return <></>
  }

  return (
    <ConfirmationModal
      opened
      title="Confirmar remoção"
      onClose={closeModal}
      onCancel={closeModal}
      onConfim={() => removeRole.mutate(role as Role)}
      confirmColor="error"
    >
      Deseja realmente remover a grupos de usuário{' '}
      <strong>{`${role?.name}?`}</strong>
    </ConfirmationModal>
  )
}
